import { ALERT_FRAGMENT } from 'features/alerts/api/fragments/alert'
import { TypedDocumentNode } from 'providers/tanstack-query/types'
import { gql } from 'providers/tanstack-query/utils'
import { Data, Variables } from './types'

export const GET_DOMAIN_AMAZON_ALERTS: TypedDocumentNode<Data, Variables> = gql`
  ${ALERT_FRAGMENT}

  query getDomainAmazonAlerts($id: ID!) {
    node(id: $id) {
      ... on DomainAmazon {
        fieldAlerts {
          ...AlertFragment
        }
      }
    }
  }
`
